import React from "react";
import classNames from "classnames";

import { Icon } from "../../common/Icon";
import { Title } from "../../common/Title";
import { ReactComponent as ShapeSvg } from "./shape.svg";
import styles from "./Newsletter.module.scss";
import { graphql, useStaticQuery } from "gatsby";

interface NewsletterProps {
  className?: string;
}

const Newsletter: React.FC<NewsletterProps> = ({ className }) => {
  const data = useStaticQuery(graphql`
    query NewsletterQuery {
      data: markdownRemark(fileAbsolutePath: { regex: "/contact.md/" }) {
        frontmatter {
          newsletter
        }
      }
    }
  `);

  if (!data.data.frontmatter.newsletter) {
    return null;
  }

  return (
    <section className={classNames(styles.newsletter, className)}>
      <div className={styles.icon}>
        <Icon name="mail" />
      </div>
      <div className={styles.right}>
        <div className={styles.form}>
          <div className={styles.formBg}>
            <ShapeSvg />
          </div>
          <div className={styles.formInner}>
            <Title size="small">Creative Elephant Newsletter</Title>
            <p>
              Want to keep your inbox up to date with all our events and
              happenings? Sign up to our newsletters and we’ll keep you in the
              loop with everything good going on in the creative elephant world.
            </p>

            <div className={styles.inputs}>
              <a
                href="http://eepurl.com/hlIU8L"
                target="_blank"
                rel="noreferrer noopener"
                className="std-button"
              >
                Sign up
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { Newsletter };
